"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { useSyncExternalStore } from "react";
import { createPortal } from "react-dom";
import { Tooltip } from "react-tooltip";
import { TOOLTIP_STYLES } from "@/helpers/tooltip.helpers";
import UserCICTypeIconTooltip from "./tooltip/UserCICTypeIconTooltip";
import UserCICTypeIcon from "./UserCICTypeIcon";
const subscribeToClientRender = () => () => undefined;
const getClientRenderSnapshot = () => true;
const getServerRenderSnapshot = () => false;
export default function UserCICTypeIconWrapper(t0) {
  const $ = _c(12);
  const {
    profile
  } = t0;
  const tooltipId = `user-cic-type-tooltip-${profile.id ?? "unknown"}`;
  const canRenderTooltip = useSyncExternalStore(subscribeToClientRender, getClientRenderSnapshot, getServerRenderSnapshot);
  let t1;
  if ($[0] !== profile.cic) {
    t1 = <UserCICTypeIcon cic={profile.cic} />;
    $[0] = profile.cic;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== tooltipId) {
    t2 = <div data-tooltip-id={tooltipId} className="tw-cursor-pointer">{t1}</div>;
    $[2] = t1;
    $[3] = tooltipId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== canRenderTooltip || $[6] !== profile || $[7] !== tooltipId) {
    t3 = canRenderTooltip && createPortal(<Tooltip id={tooltipId} clickable={true} place="right" positionStrategy="fixed" opacity={1} style={{
      ...TOOLTIP_STYLES,
      padding: "0",
      maxWidth: "360px",
      pointerEvents: "auto"
    }}><UserCICTypeIconTooltip profile={profile} /></Tooltip>, document.body);
    $[5] = canRenderTooltip;
    $[6] = profile;
    $[7] = tooltipId;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}